define.alias("shared/components/shared/plan-recommendation/progress-bar", "preview-grid/components/shared/plan-recommendation/progress-bar");